import { render, staticRenderFns } from "./CompanyResult.vue?vue&type=template&id=5d894f3e"
import script from "./CompanyResult.vue?vue&type=script&lang=js"
export * from "./CompanyResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports